import { Point } from "pixi.js";
import { ArcadeWheelLandscapeProperties } from "../landscape/ArcadeWheelLandscapeProperties";
/**
 * ArcadeWheelPortraitProperties.ts
 */
export class ArcadeWheelPortraitProperties extends ArcadeWheelLandscapeProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.spinCounterTextProperties.position.set(-169, 340);
        this.qButtonProperties.position.set(250, 184);
        this.scaleNotInProgress.set(0.48);
        this.scaleInProgress.set(0.8);
        this.scaleHidden.set(0.48);
        this.offsetNotInProgress.set(134, 122);
        this.offsetInProgress.set(134, 47);
        this.offsetHidden.set(134, 895);
        this.instructionsProperties.size = new Point(930, 900);
        this.instructionsProperties.position.set(512, 406);
    }
}
//# sourceMappingURL=ArcadeWheelPortraitProperties.js.map